export default function (state) {
    if (state === undefined) {
        return '';
    }

    return state;
}



// WEBPACK FOOTER //
// ./js/shared/reducers/domainReducer.js